import { __assign, __rest } from "tslib";
/* eslint-disable filenames/match-exported */
// ^ This component is a subcomponent so it uses a `SelectMenu.Subcomponent` filename
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './SelectMenu.Item.scss';
var SelectMenuItem = function (_a) {
    var _isFocused = _a._isFocused, _isSelected = _a._isSelected, _onClick = _a._onClick, _onMouseEnter = _a._onMouseEnter, children = _a.children, isDisabled = _a.isDisabled, value = _a.value, props = __rest(_a, ["_isFocused", "_isSelected", "_onClick", "_onMouseEnter", "children", "isDisabled", "value"]);
    var containerClass = classnames('SelectMenuItem u-truncate', {
        'SelectMenuItem--isFocused': _isFocused,
        'SelectMenuItem--isSelected': _isSelected
    });
    var handleMouseEnter = function () {
        if (!isDisabled && _onMouseEnter) {
            _onMouseEnter();
        }
    };
    return (React.createElement("button", __assign({}, props, { className: containerClass, disabled: isDisabled, onClick: function () { return _onClick === null || _onClick === void 0 ? void 0 : _onClick(value); }, 
        // Since <SelectMenu> manages a focusedIndex, only one element can have
        // focus at a time, so mouseleave is not needed to blur focus.
        onMouseEnter: handleMouseEnter, role: 'menuitem', type: 'button' }), children));
};
SelectMenuItem.defaultProps = {
    _isFocused: false,
    _isSelected: false,
    isDisabled: false
};
SelectMenuItem.propTypes = {
    // Programmatically-Injected Props
    _isFocused: PropTypes.bool,
    _isSelected: PropTypes.bool,
    _onClick: PropTypes.func,
    _onMouseEnter: PropTypes.func,
    // When more complex elements are added as a child,
    // [data-filter-item] can be used to designate the filter term
    children: PropTypes.node.isRequired,
    isDisabled: PropTypes.bool,
    value: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.number,
        PropTypes.string,
    ]).isRequired
};
export default SelectMenuItem;
//# sourceMappingURL=SelectMenu.Item.js.map